import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { style: {"mix-blend-mode":"luminosity"} }, [
      _createElementVNode("rect", {
        width: "24",
        height: "24",
        fill: "#efffff",
        rx: "12"
      }),
      _createElementVNode("path", {
        fill: "#1a968d",
        "fill-rule": "evenodd",
        d: "m17.096 7.39-7.16 6.91-1.9-2.03c-.35-.33-.9-.35-1.3-.07-.39.29-.5.8-.26 1.21l2.25 3.66c.22.34.6.55 1.03.55.41 0 .8-.21 1.02-.55.36-.47 7.23-8.66 7.23-8.66.9-.92-.19-1.73-.91-1.03z",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]))]))
}
export default { render: render }